import AuthService from "./AuthService";
import AuthApi from "./AuthApi";
import environment from '../../environment';

export default class AuthRUService extends AuthService {
    static iniciarLoginUnificado() {
        const loginUnificadoUrl = `${environment.loginUnificadoUrl}/${environment.sistema}`;
        window.location.href = loginUnificadoUrl;
    }

    static async finalizarLoginComSessao(loginSession) {
        try {
            let res = await AuthApi.post(`v2/authenticate/finalize`, { mfaSessionId: loginSession });
            let authorization = res.data.data;

            if (authorization && authorization.token) {
                this._saveCredentials(authorization);
                return true;
            }
            return false;
        } catch (error) {
            console.error('Erro na sincronização de sessão:', error);
            return false;
        }
    }

    static async completeMfa({ code, state }) {
        try {
            let res = await AuthApi.post(`v2/authenticate/mfa/finalize`, { code, state });
            let authorization = res.data.data;
            if (authorization && authorization.token) {
                this._saveCredentials(authorization);
                return true;
            }
            return false;
        } catch (error) {
            console.error('Erro no processamento MFA:', error);
            return false;
        }
    }

    static async refreshCredentials() {
        return AuthApi.get(`v1/authenticate/refreshcredentials/${environment.sistema}`, {
            headers: { authorization: `Bearer ${this.getToken()}` }
        }).then(response => {
            const data = response.data.data || response.data;
            if (data && (data.token || data.Token)) {
                this._saveCredentials(data);
                return true;
            }
            return false;
        });
    }
}